import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import * as ApiUpdatePassword from '../interfaces/api/update-password';
import * as ApiAlamat from '../interfaces/api/alamat';
import * as ApiCustomerBank from '../interfaces/api/customer_bank';
import * as ApiFAQ from '../interfaces/api/faq';
import * as ApiUpdatePhone from '../interfaces/api/update-phone';

@Injectable({
  providedIn: 'root',
})
export class ProfileService extends BaseService {
  constructor(private http: HttpClient) {
    super();
  }

  updatePassword(payload: ApiUpdatePassword.RequestBody) {
    return this.http.post(`${this.apiUrl}/profile/change-password`, payload);
  }

  addAlamat(payload: ApiAlamat.RequestBody) {
    return this.http.post(`${this.apiUrl}/customer_address`, payload);
  }

  getAlamat() {
    return this.http.get<ApiAlamat.GetRequestBody>(`${this.apiUrl}/customer_address`);
  }

  getActiveAlamat(){
    return this.http.get<ApiAlamat.GetShowRequestBody>(`${this.apiUrl}/customer_address/active`);
  }

  detailAlamat(idAddress: string) {
    return this.http.get<ApiAlamat.GetShowRequestBody>(`${this.apiUrl}/customer_address/${idAddress}`);
  }

  deleteAlamat(idAddress: number) {
    return this.http.delete<ApiAlamat.GetRequestBody>(`${this.apiUrl}/customer_address/${idAddress}`);
  }

  updateAlamat(payload: ApiAlamat.RequestBodyUpdate) {
    return this.http.post(`${this.apiUrl}/customer_address/${payload.id}?_method=patch`, payload);
  }

  updateAlamatToActive(idAddress: number) {
    return this.http.patch(`${this.apiUrl}/customer_address/set_default/${idAddress}`, '');
  }

  getCustomerBank() {
    return this.http.get<ApiCustomerBank.ResponseBody>(`${this.apiUrl}/customer_bank`);
  }

  deleteCustomerBank(idAddress: number) {
    return this.http.delete<ApiCustomerBank.ResponseBody>(`${this.apiUrl}/customer_bank/${idAddress}`);
  }

  updateCustomerBankToActive(idAddress: number) {
    return this.http.patch(`${this.apiUrl}/customer_bank/set_default/${idAddress}`, '');
  }

  addCustomerBank(payload: ApiCustomerBank.RequestBody) {
    return this.http.post(`${this.apiUrl}/customer_bank`, payload);
  }

  updateCustomerBank(payload: ApiCustomerBank.RequestBody) {
    return this.http.post(`${this.apiUrl}/customer_bank/${payload.id}?_method=patch`, payload);
  }

  getFAQ() {
    return this.http.get<ApiFAQ.ResponseBodyGetFAQ>(`${this.apiUrl}/faq`);
  }

  checkPhone(payload: any) {
    return this.http.post(`${this.apiUrl}/check_telp_hp`, payload);
  }

  updatePhone(payload: ApiUpdatePhone.RequestBody) {
    return this.http.post(`${this.apiUrl}/profile/change_phone`, payload);
  }
}
